import axios from "axios";

// Prefer explicit env override, otherwise pick the production API domain when we are
// on the public site and fall back to the local proxy in development.
const isProdHost =
  typeof window !== "undefined" &&
  window.location.hostname.endsWith("gestionesinistri.eu");

const apiBase =
  process.env.REACT_APP_API_BASE ||
  (isProdHost ? "https://api.gestionesinistri.eu/api/" : "/api/");

export default axios.create({
  baseURL: apiBase,
  withCredentials: true, //Necessario per salvare i cookies
  headers: {
    "Content-type": "application/json",
  },
});
